var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchMsg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "445 245 70 70",
    style: {
      enableBackground: "new 445 245 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E8F3F9;}\n\t.st1{fill:#339DD3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 480,
    cy: 280,
    r: 35
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M476.8,297.1c11.2,0,20.3-9.1,20.3-20.3s-9.1-20.3-20.3-20.3s-20.3,9.1-20.3,20.3S465.6,297.1,476.8,297.1z  M476.8,259.6c9.5,0,17.2,7.7,17.2,17.2s-7.7,17.2-17.2,17.2s-17.2-7.7-17.2-17.2C459.6,267.3,467.3,259.6,476.8,259.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M468,285.6c-4.9-4.9-4.9-12.8,0-17.7l2.2,2.2c-3.6,3.7-3.6,9.6,0,13.3L468,285.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M502.1,302.1c-0.9,0.9-2.1,1.4-3.3,1.4s-2.4-0.5-3.3-1.4l-8.7-8.5l2.2-2.2l8.7,8.5c0.6,0.6,1.6,0.6,2.2,0 c0.3-0.3,0.5-0.7,0.5-1.1s-0.2-0.8-0.5-1.1l-8.5-8.8l2.2-2.2l8.5,8.7c0.9,0.9,1.4,2,1.4,3.3C503.5,300.1,503,301.2,502.1,302.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMsg);
export default __webpack_public_path__ + "static/media/search_msg.e7aa93f2a2a41cd8b7fbedd559284440.svg";
export { ForwardRef as ReactComponent };